// Which deploy target this bundle was built for.
//   'local'      — `npm run dev`
//   'dev'        — `npm run build-dev`, served at visu.dev.dinoconnect.de
//   'production' — `npm run build`, served at visu.dinoconnect.de
export type AppEnv = 'local' | 'dev' | 'production'

export const APP_ENV: AppEnv = import.meta.env.DEV
  ? 'local'
  : (import.meta.env.VITE_APP_ENV as AppEnv) || 'production'

export const IS_PRODUCTION_BUILD = APP_ENV === 'production'

// Short label for the version readout in the Navbar, e.g. "v0.9.2 · dev".
export const APP_ENV_LABEL = IS_PRODUCTION_BUILD ? '' : APP_ENV.toUpperCase()
